import { getAllEntities } from '@adornis/baseql/operations/mongo.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { HealthInsurance } from '../../healthinsurance/entities/HealthInsurance.js';

export async function generateKrankenkassenLodasData(satzNummer: string) {
  const mappedLine: string[] = [];
  const allInsurences = await getAllEntities(HealthInsurance)(selectionSet(() => HealthInsurance, 1));

  for (const kk of allInsurences) {
    if (!kk.betriebsnummer || !kk.krankenkasse) continue;

    mappedLine.push(
      `${satzNummer};${(typeof kk.krankenkasse === 'string'
        ? parseInt(kk.krankenkasse)
        : kk.krankenkasse
      ).toString()};${kk.betriebsnummer};${(kk.bezeichnung ?? '').slice(0, 22)};`,
    );
  }

  return mappedLine.join('\r\n');
}
